/**
 * Map retired / redirected course paths to their final public URLs.
 * Used when rendering internal course cards and listing hrefs so hubs
 * link straight to the destination (external redirects stay in next.config).
 */

const FINAL_RF_ULTRASOUND =
  "/courses/beauty/radiofrequency-ultrasound-cavitation-fat-reduction-and-skin-tightening-training/";

/** Old path (with or without trailing slash) → final path (with trailing slash). */
export const COURSE_CANONICAL_URL_BY_PATH: Record<string, string> = {
  "/courses/beauty/radiofrequency-skin-tightening": FINAL_RF_ULTRASOUND,
  "/courses/beauty/ultrasound-cavitation": FINAL_RF_ULTRASOUND,
  "/courses/aesthetics/lidocaine-infusion-training-course":
    "/courses/elearning/online-lidocaine-infusion-training/",
  "/courses/aesthetics/fast-track-to-aesthetics": "/pathway-to-aesthetics/",
  "/courses/packages/pathway-to-aesthetics-training-package":
    "/pathway-to-aesthetics/",
  "/courses/semi-permanent-makeup/microblading":
    "/courses/vtct/level-4-certificate-in-enhancing-eyebrows-with-microblading-techniques/",
  "/courses/semi-permanent-makeup/ultimate-permanent-makeup":
    "/courses/vtct/level-4-certificate-in-micropigmentation/",
  "/courses/beauty/waxing": "/courses/elearning/face-and-body-waxing/",
  "/courses/beauty/intimate-waxing": "/courses/elearning/face-and-body-waxing/",
};

export function normalizeCoursePathKey(url: string | null | undefined): string {
  if (!url) return "";
  let pathname = String(url).trim();
  try {
    if (/^https?:\/\//i.test(pathname)) {
      pathname = new URL(pathname).pathname;
    }
  } catch {
    // keep pathname as-is
  }
  return pathname.split("?")[0].split("#")[0].replace(/\/+$/, "") || "";
}

/** Resolve a course URL to its final public path (trailing slash). */
export function resolveCourseCanonicalUrl(
  url: string | null | undefined,
): string {
  if (!url) return "";
  const key = normalizeCoursePathKey(url);
  if (!key) return "";

  const mapped = COURSE_CANONICAL_URL_BY_PATH[key];
  if (mapped) return mapped;

  const withSlash = key.startsWith("/") ? `${key}/` : `/${key}/`;
  return withSlash;
}

/** Hub sidebar category labels that must use hyphenated slugs. */
export const COURSE_CATEGORY_HUB_SLUGS: Record<string, string> = {
  "medical professionals": "medical-professionals",
};

export function resolveCourseCategoryHubPath(category: string): string {
  const slug =
    COURSE_CATEGORY_HUB_SLUGS[category] ||
    category.trim().replace(/\s+/g, "-");
  return `/courses/${slug}/`;
}
